function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  data: function data() {
    return {
      baseUrl: "/api/amenities/",
      headers: ["Amenity Name", "Description", "Base Value"],
      updateItems: null,
      amenities: [],
      money: {
        decimal: ".",
        thousands: ",",
        prefix: "$",
        suffix: "",
        precision: 2,
        masked: false
      }
    };
  },
  mounted: function mounted() {
    var _this = this;

    axios.get(this.baseUrl).then(function (response) {
      _this.amenities = response.data;
    });
  },

  methods: {
    addNew: function addNew() {
      if (this.updateItems !== null) {
        this.$snotify.info("Please finish your current edit first");
      } else {
        this.amenities = [{
          id: null,
          name: "",
          value: 0.0
        }].concat(_toConsumableArray(this.amenities));
        this.updateItems = 0;
      }
    },
    removeItem: function removeItem(idx) {
      this.amenities.splice(idx, 1);
    },
    removeAmenity: function removeAmenity(idx) {
      var _this2 = this;

      var amenityToRemove = this.amenities[idx];
      if (amenityToRemove.id !== null) {
        axios.delete("" + this.baseUrl + amenityToRemove.id).then(function (response) {
          if (response instanceof Error) {
            return Promise.reject();
          }
          _this2.updateItems = null;
          _this2.$snotify.success("\"" + amenityToRemove.name + "\" has been deleted");
          _this2.removeItem(idx);
        }).catch(function (_) {
          _this2.$snotify.warning("There was a problem deleting the amenity");
        });
      } else {
        this.removeItem(idx);
      }
      this.updateItems = null;
    },
    saveAmenity: function saveAmenity(idx) {
      var _this3 = this;

      var amenityToSave = this.amenities[idx];
      if (amenityToSave.id !== null) {
        axios.patch("" + this.baseUrl + amenityToSave.id, amenityToSave).then(function (response) {
          if (response instanceof Error) {
            return Promise.reject();
          }
          _this3.updateItems = null;
          _this3.$snotify.success("Amenity updated successfully");
        }).catch(function (_) {
          _this3.$snotify.warning("There was a problem updating the amenity");
        });
      } else {
        axios.post(this.baseUrl, amenityToSave).then(function (response) {
          if (response instanceof Error) {
            return Promise.reject();
          }
          _this3.updateItems = null;
          _this3.amenities[idx] = response.data;
          _this3.$snotify.success("Amenity created successfully");
        }).catch(function (_) {
          _this3.$snotify.warning("There was a problem creating the amenity");
        });
      }
    }
  }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"cacheDirectory":true,"presets":[["env",{"modules":false,"targets":{"browsers":["> 2%"],"uglify":true}}]],"plugins":["transform-object-rest-spread",["transform-runtime",{"polyfill":false,"helpers":false}]],"env":{"test":{"presets":[["env",{"targets":{"node":"current"}}]]},"development":{"presets":[["env",{"modules":false}]]},"production":{"presets":[["env",{"modules":false,"targets":{"browsers":"> 2%","uglify":true}}]]}}}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/components/settings/properties/AmenitiesList.vue
// module id = y50a
// module chunks = 0 1